import React, { useEffect, useState } from "react";
import { Box, Grid, IconButton, Modal, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

function PhotoFullPage({ photo }) {
    const [photos, setPhotos] = useState([]);

    const [open, setOpen] = useState("");
    const [id, setId] = useState(-1);
    const [label, setLabel] = useState("");

    const handleClose = () => {
        setOpen("");
        setId(-1);
    };

    useEffect(() => {
        const loadPhotos = async () => {
            let indents = [];
            for (let i = 0; i < photo.maximo; i++) {
                indents.push(
                    <img
                        id={i}
                        onClick={(e) => {
                            setId(i)
                            setOpen(
                                photo.ID.length > 5
                                    ? `https://galeria-images.s3.sa-east-1.amazonaws.com/${photo.ID}/galeria/${i}_max.jpeg`
                                    : `https://galeria-images.s3.sa-east-1.amazonaws.com/${photo.ID}/galeria/${i}_max.jpg`
                            );
                        }}
                        src={
                            photo.ID.length > 5
                                ? `https://galeria-images.s3.sa-east-1.amazonaws.com/${photo.ID}/galeria/${i}_max.jpeg`
                                : `https://galeria-images.s3.sa-east-1.amazonaws.com/${photo.ID}/galeria/${i}_max.jpg`
                        }
                        width={"350px"}
                        height={"175px"}
                        alt="imagem de capa da noticia"
                        style={{
                            objectFit: "cover",
                            minWidth: "200px",
                        }}
                    />
                );
            }

            setPhotos(indents);
        };

        const loadPhotosList = async () => {
            console.log(photo.photos)
            let indents = photo.photos.filter(i => i && i.url).map((item, i) => (
                <img
                    id={i}
                    onClick={(e) => {
                        setOpen(item.url);
                        setLabel(item.label);
                        setId(i)
                    }}
                    src={item.url}
                    width={"350px"}
                    height={"175px"}
                    alt="imagem de capa da noticia"
                    style={{
                        objectFit: "contain",
                        minWidth: "200px",
                        backgroundColor: '#000'
                    }}
                />
            ));

            console.log(indents)
            setPhotos(indents);
        };

        if (photo.photos && photo.photos.length !== 0) {
            loadPhotosList();
        } else {
            loadPhotos();
        }
    }, [photo]);

    function formatDate(date) {
        const months = [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro",
        ];
        const newDate = new Date(date);

        return `${newDate.getDate()} de ${
            months[newDate.getMonth()]
        } de ${newDate.getFullYear()}`;
    }

    return (
        <Box marginBottom={2} p={4}>
            <Modal
                open={open === "" ? false : true}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box
                    style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        p: 4,
                    }}
                >
                    <Typography
                        id="modal-modal-title"
                        component="h2"
                        sx={{
                            position: "absolute",
                            width: 1,
                            height: 1,
                            padding: 0,
                            margin: -1,
                            overflow: "hidden",
                            clip: "rect(0, 0, 0, 0)",
                            whiteSpace: "nowrap",
                            border: 0,
                        }}
                    >
                        Foto em visualização ampliada
                    </Typography>
                    <Typography
                        id="modal-modal-description"
                        component="p"
                        sx={{
                            position: "absolute",
                            width: 1,
                            height: 1,
                            padding: 0,
                            margin: -1,
                            overflow: "hidden",
                            clip: "rect(0, 0, 0, 0)",
                            whiteSpace: "nowrap",
                            border: 0,
                        }}
                    >
                        {label || "Imagem da galeria"}
                    </Typography>
                    {parseInt(id) !== 0 && (
                        <IconButton
                            aria-label="Foto anterior"
                            onClick={() => {
                                const opened = parseInt(id) - 1;
                                if (opened >= 0) {
                                    setId(opened);
                                    if (photo.photos && photo.photos.length > 0) {
                                        setOpen(photo.photos[opened].url);
                                    } else {
                                        setOpen(photo.ID.length > 5
                                            ? `https://galeria-images.s3.sa-east-1.amazonaws.com/${photo.ID}/galeria/${opened}_max.jpeg`
                                            : `https://galeria-images.s3.sa-east-1.amazonaws.com/${photo.ID}/galeria/${opened}_max.jpg`);
                                    }
                                }
                            }}
                            sx={{
                                position: "absolute",
                                top: "50%",
                                left: "20px",
                                transform: "translate(-50%, -50%)",
                                color: "#FFF",
                            }}
                        >
                            <ChevronLeft sx={{ fontSize: 48 }} />
                        </IconButton>
                    )}
                    {parseInt(id) + 1 !== photo.maximo && (
                        <IconButton
                            aria-label="Próxima foto"
                            onClick={() => {
                                const opened = parseInt(id) + 1;
                                if (opened < photo.maximo) {
                                    setId(opened);
                                    if (photo.photos && photo.photos.length > 0) {
                                        setOpen(photo.photos[opened].url);
                                    } else {
                                        setOpen(photo.ID.length > 5
                                            ? `https://galeria-images.s3.sa-east-1.amazonaws.com/${photo.ID}/galeria/${opened}_max.jpeg`
                                            : `https://galeria-images.s3.sa-east-1.amazonaws.com/${photo.ID}/galeria/${opened}_max.jpg`);
                                    }
                                }
                            }}
                            sx={{
                                position: "absolute",
                                top: "50%",
                                right: "10px",
                                transform: "translate(-50%, -50%)",
                                color: "#FFF",
                            }}
                        >
                            <ChevronRight sx={{ fontSize: 48 }} />
                        </IconButton>
                    )}
                    <img
                        onClick={handleClose}
                        src={open}
                        alt="imagem de capa da noticia"
                        style={{
                            objectFit: "cover",
                            minWidth: "200px",
                            maxWidth: "90vw",
                        }}
                    />
                    <Typography
                        color="#010101"
                        fontFamily="Raleway"
                        fontStyle="normal"
                        fontWeight="500"
                        fontSize="24px"
                        lineHeight="37.57px"
                        backgroundColor="#FFFFFF90"
                        padding={label !== "" ? 1 : 0}
                    >
                        {label}
                    </Typography>
                </Box>
            </Modal>
            <Grid
                container
                display={"flex"}
                mt={2}
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Grid xs={12} md={6}>
                    <Typography
                        color="#010101"
                        fontFamily="Raleway"
                        fontStyle="normal"
                        fontWeight="700"
                        fontSize="32px"
                        lineHeight="37.57px"
                    >
                        {photo.titulo}
                    </Typography>
                    <Grid xs={12} md={12}>
                        <Typography
                            color="#010101"
                            fontFamily="Raleway"
                            fontStyle="normal"
                            fontWeight="400"
                            fontSize="12px"
                            lineHeight="14px"
                        >
                            {formatDate(photo.incData)}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid
                    xs={12}
                    md={8}
                    gap={2}
                    marginTop={6}
                    container
                    marginY={6}
                    display={"flex"}
                >
                    {photos}
                </Grid>
            </Grid>
        </Box>
    );
}

export default PhotoFullPage;
